import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Rgba {
  r: number;
  g: number;
  b: number;
  a?: number;
}

@Injectable({
  providedIn: 'root',
})

export class CurrentColorService {
  private currentColorSubject = new BehaviorSubject<string | null>(null);
  currentColor$ = this.currentColorSubject.asObservable();

  setCurrentColor(color: string): void {
    this.currentColorSubject.next(color);
  }

  resetCurrentColor(): void {
    this.currentColorSubject.next(null);
  }

  hexToRgb(color: string): Rgba {
    if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(color)) {
      throw new Error('Invalid HEX color format');
    }
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    const a = color.length === 9 ? parseInt(color.slice(7, 9), 16) / 255 : 1;
    return { r, g, b, a };
  }

  rgbaToString({ r, g, b, a = 1 }: Rgba): string {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  getLevelColor(baseColor: string, level: number): string {
    const { r, g, b } = this.hexToRgb(baseColor);
    const alpha = Math.max(1 - level * 0.4, 0.1);
    return `rgba(${r}, ${g}, ${b}, ${alpha.toFixed(2)})`;
  }

  getBorderLeftWidth(level: number): string {
    switch (level) {
      case 0:
      case 1:
      case 2:
        return '10px';
      case 3:
      case 4:
        return '20px';
      case 5:
        return '40px';
      case 6:
        return '70px';
      case 7:
      case 8:
        return '100px';
      case 9:
        return '140px';
      default:
        return '10px';
    }
  }
}